// B2B Sidebar Component - AIAgentify
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';

export default function B2BSidebar({ newLeadsCount = 0 }) {
  const { logout } = useB2B();
  const location = useLocation();
  const navigate = useNavigate();

  const isSettingsTabActive = (tab) => {
    const params = new URLSearchParams(location.search);
    return location.pathname === '/settings' && params.get('tab') === tab;
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="b2b-sidebar">
      <NavLink to="/" end className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}>
        <span className="icon">📊</span>
        Dashboard
      </NavLink>
      
      <NavLink to="/leads" className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}>
        <span className="icon">👥</span>
        Leads
        {newLeadsCount > 0 && <span className="b2b-nav-badge">{newLeadsCount}</span>}
      </NavLink>
      
      <div className="b2b-sidebar-divider" />
      <div className="b2b-sidebar-section">Widget</div>
      
      <NavLink to="/widget-content" className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}>
        <span className="icon">🎯</span>
        Content
      </NavLink>
      
      <NavLink to="/settings?tab=branding" className={() => `b2b-nav-item ${isSettingsTabActive('branding') || (location.pathname === '/settings' && !location.search) ? 'active' : ''}`}>
        <span className="icon">🎨</span>
        Branding
      </NavLink>
      
      <NavLink to="/settings?tab=widget" className={() => `b2b-nav-item ${isSettingsTabActive('widget') ? 'active' : ''}`}>
        <span className="icon">💬</span>
        Widget Settings
      </NavLink>
      
      <NavLink to="/settings?tab=ai" className={() => `b2b-nav-item ${isSettingsTabActive('ai') ? 'active' : ''}`}>
        <span className="icon">🧠</span>
        AI Settings
      </NavLink>
      
      <NavLink to="/settings?tab=embed" className={() => `b2b-nav-item ${isSettingsTabActive('embed') ? 'active' : ''}`}>
        <span className="icon">🔗</span>
        Embed Code
      </NavLink>

      <div className="b2b-sidebar-divider" />
      <div className="b2b-sidebar-section">Account</div>
      
      <NavLink to="/settings?tab=notifications" className={() => `b2b-nav-item ${isSettingsTabActive('notifications') ? 'active' : ''}`}>
        <span className="icon">🔔</span>
        Notifications
      </NavLink>
      
      <NavLink to="/billing" className={({ isActive }) => `b2b-nav-item ${isActive ? 'active' : ''}`}>
        <span className="icon">💳</span>
        Billing
      </NavLink>
      
      <div className="b2b-sidebar-divider" />
      
      <button className="b2b-nav-item" onClick={handleLogout} style={{ marginTop: 'auto' }}>
        <span className="icon">🚪</span>
        Sign Out
      </button>
    </aside>
  );
}
